<template>
  <div class="banner" v-scroll="onScroll" v-resize="onResize">
		<component-icon-networks
		:offset-top="offsetTop"
		:window-size="windowSize"
		:links="links"
		/>
		<v-flex text-xs-center>
			<a href="/">
				<img :src="logoApprunn" alt="">
			</a>
		</v-flex>
		<v-flex text-xs-center class="description-banner  white--text">No somos una software factory, somos un product studio, es decir, 
			desarrollamos plataformas que solucionan problemas a diferentes sectores del mercado. 
		</v-flex>
		<v-layout xs12 align-center justify-center class="responsive-column">
			<v-flex :class="windowSize.x < 1024 ? 'xs12 text-xs-center' : 'xs6 text-xs-right'">
				<p class="title-light-blue font-size"> ROMPEMOS
					<br> <span class="text-white white--text">PARADIGMAS</span>
				</p>
				</v-flex>
				<v-flex :class="windowSize.x < 1024 ? 'xs12 text-xs-left' : 'xs6'" class="white--text content-white">
					<p class="max-width">
						Somos un <span class="border-bottom">Product Studio</span> hecho en Perú, nuestra misión es crear productos que solucionen la vida de la gente sin importar donde estén y asegurándonos su crecimiento constante.
					</p>
			</v-flex>
		</v-layout>
		<component-description />
	</div>
</template>

<script>
import componentDescription from '@/components/home/component-description';
import componentIconNetworks from '@/components/home/component-icon-networks';

function onScroll() {
	this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
}

function onResize() {
	this.windowSize = { x: window.innerWidth, y: window.innerHeight };
}

function data() {
	return {
		logoApprunn: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/logo-apprunn.svg',
		offsetTop: 0,
		windowSize: {
			x: 0,
			y: 0,
		},
	};
}

export default {
	name: 'banner',
	data,
	components: {
		componentDescription,
		componentIconNetworks,
	},
	methods: {
		onScroll,
		onResize,
	},
	props: {
		links: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.banner {
	background-image: url('https://web-apprunn.s3-sa-east-1.amazonaws.com/cyber-armis+(1).png');
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 100vh;
	padding-top: 127px;
	position: relative;
	width: 100%;
	z-index: 2;

	@media (max-width: 1024px) {
		padding: 64px 50px;
		height: 850px;
	}
}

.description-banner {
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: map-get($sizes, large);
	margin: 66px auto 92px auto;
	max-width: 440px;

	@media (max-width: 1024px) {
		margin-top: 40px auto 59px auto;
	}
}

.title-light-blue {
	color: map-get($colors, regular);
	font-family: 'Lato', sans-serif;
	font-weight: 900;

	@media (max-width: 1024px) {
		font-size: 24px;
		margin: 0;
	}
}

.text-white {
	font-family: map-get($fonts, LatoBold);

	@media (max-width: 1024px) {
		font-size: 24px;
	}
}


.border-bottom {
	border-bottom: 1px solid map-get($colors, white);
}

.content-white {
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: map-get($sizes, medium);

	@media (max-width: 1024px) {
		margin-top: 25px;
		text-align: center !important;
	}
}

.responsive-column {
	@media (max-width: 1024px) {
		flex-direction: column;
	}
}

.max-width {
	@media (min-width: 1024px) {
		margin: 0 0 0 25px;
		max-width: 338px;
	}
}

.font-size {
	font-size: 56px;

	@media (max-width: 1024px	) {
		font-size: 24px;	
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home/banner.vue